import { render, staticRenderFns } from "./promotion-maintenance-form-wrapper.vue?vue&type=template&id=adc4a35a"
import script from "./promotion-maintenance-form-wrapper.vue?vue&type=script&lang=js"
export * from "./promotion-maintenance-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports